module.exports = __webpack_public_path__ + "static/media/discard.0f014891.svg";